<template>
  <section class="collapsable">
    <div class="d-flex justify-content-between align-items-center">

      <h3 v-if="title" class="mb-0">{{ title }}</h3>

      <h5 v-if="title_h5" class="mb-0">{{ title_h5 }}</h5>

      <div class="d-flex justify-content-end align-items-center">
        <div class="before-collapse" v-if="!isCollapsed">
          <slot name="beforeCollapse"></slot>
        </div>
        <span v-if="collapsable" @click.prevent="isCollapsed = !isCollapsed">
          <i class="fa clickable p-3" :class="{'fa-chevron-up': !isCollapsed, 'fa-chevron-down': isCollapsed}"></i>
        </span>
      </div>
    </div>

    <fade-transition
      :duration="200"
      mode="out-in">

      <div v-show="!isCollapsed" class="collapsable-content">
        <slot></slot>
      </div>

    </fade-transition>

  </section>
</template>
<script>
import FadeTransition from '@/components/common/transitions/FadeTransition'
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    title_h5: {
      type: String,
      required: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    FadeTransition
  },
  data: function () {
    return {
      isCollapsed: false
    }
  },
  watch: {
    collapsed: {
      handler: function (value) {
        this.isCollapsed = value
      },
      immediate: true
    }
  }
}
</script>
